import { useState } from 'react'
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { PresentationPhotoSource } from '../diagnostics/planPresentation'
import { resolvePhotoPreviewSrc } from './resolvePhotoPreviewSrc'
import { useAuthedPreviewUrl } from './useAuthedPreviewUrl'

function formatBytes(n: number) {
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`
  return `${(n / (1024 * 1024)).toFixed(1)} MB`
}

export function PresentationPhotoCard({
  photo,
  checked,
  disabled,
  bootstrap,
  accessToken,
  onToggle,
  onPreview,
}: {
  photo: PresentationPhotoSource
  checked: boolean
  disabled?: boolean
  bootstrap: TenantBootstrapModel
  accessToken: string
  onToggle: () => void
  onPreview?: () => void
}) {
  const [imgFailed, setImgFailed] = useState(false)
  const rawSrc = resolvePhotoPreviewSrc(photo, bootstrap)
  const displaySrc = useAuthedPreviewUrl(rawSrc, accessToken, bootstrap)

  return (
    <div
      className={`relative flex flex-col overflow-hidden rounded-lg border bg-white shadow-sm transition ${
        checked ? 'border-indigo-400 ring-1 ring-indigo-200' : 'border-slate-200'
      }`}
    >
      <label className="absolute left-2 top-2 z-10 flex cursor-pointer items-center rounded bg-white/90 p-1 shadow-sm">
        <input
          type="checkbox"
          className="h-4 w-4"
          checked={checked}
          disabled={disabled}
          onChange={onToggle}
        />
      </label>
      <button
        type="button"
        className="relative aspect-[4/3] w-full overflow-hidden bg-slate-100"
        disabled={!displaySrc || imgFailed}
        onClick={onPreview}
      >
        {displaySrc && !imgFailed ? (
          <img
            src={displaySrc}
            alt={photo.display_name}
            loading="lazy"
            className="h-full w-full object-cover"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <div className="flex h-full items-center justify-center px-2 text-center text-[10px] text-slate-500">
            {imgFailed ? 'Нет превью' : 'Загрузка…'}
          </div>
        )}
      </button>
      <div className="space-y-0.5 p-2 text-[11px]">
        <p className="truncate font-medium text-slate-800" title={photo.display_name}>
          {photo.display_name}
        </p>
        <p className="text-slate-500">
          {photo.source === 'plan_media' ? 'План' : photo.source_label ?? 'NAS'} · {formatBytes(photo.size_bytes)}
        </p>
      </div>
    </div>
  )
}
